import _get from 'lodash/get';

// default delay 10 minutes
export const expirationTimeout = (delay=10) => {
  const now = new Date();
  return new Date(now.getTime() + delay*60000);
};

export const isValidExpirationToken = (expirationToken) => {
  return new Date() < expirationToken;
};

export const marketingProfilePayload = ({ email, rut, phone, name, fatherLastName, motherLastName }) => ({
  email, rut, phone,
  'name_lastname': `${name} ${fatherLastName} ${motherLastName}`,
  'profile': true,
  'origin': 'IDAR'
});

export const profilePayload = ({ email, rut, phone, name, fatherLastName, motherLastName }) => ({
  rut, phone: phone.replace(/\+/g, ''),
  name, email,
  fatherLastName,
  motherLastName,
  userUpdated: true
});

export const pickProfileResponse = response => {
  return _get(response, 'data.response.msg.data.profile', null);
};
